import { searchAppOwnersApi } from 'lib/actions/apps/app-owners'
import { UserValue } from 'lib/actions/user'
import { RoleID } from 'lib/constants/system'
import { UserContext } from 'lib/context/app'
import { AppOwnerRef, SearchAppOwnersRequest } from 'pbts/c1/api/app/v1/app_owner'
import { useContext } from 'react'
import { SerializedErrorType } from 'redux_toolkit/lib/reducer'

export const useIsAppOwner = (appId: string): [boolean, boolean, Readonly<SerializedErrorType> | undefined] => {
    const userContext = useContext(UserContext)

    const {
        data: appOwnerData,
        error: appOwnerError,
        isLoading: isAppOwnerLoading,
    } =
  searchAppOwnersApi.useSearch(
      SearchAppOwnersRequest.create({
          appId,
          refs: [AppOwnerRef.create({ id: userContext.user.id, appId })],
      }),
      { notify: true },
  )
    const appOwnersList = appOwnerData[0] as UserValue[] || []
    const isSuperAdmin = userContext.user.roleIds.includes(RoleID.SuperAdmin)
    const hasAppAdmin = userContext.user.roleIds.includes(RoleID.ApplicationAdmin)
    const userIsOwner = hasAppAdmin && appOwnersList.some((owner) => owner.id === userContext.user.id)

    return [userIsOwner || isSuperAdmin, isAppOwnerLoading, appOwnerError]
}
